import React from 'react';
import { HiX } from 'react-icons/hi';
import { BsImages, BsStars } from 'react-icons/bs';
import { motion, AnimatePresence } from 'framer-motion';

const ImageChatHeader = ({ 
    title, 
    onClose, 
    selectedImagesCount, 
    maxImages 
}) => {
    return (
        <motion.div 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="relative overflow-hidden"
        >
            {/* Animated Background Gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500/10 via-orange-500/10 to-rose-500/10 dark:from-pink-500/5 dark:via-orange-500/5 dark:to-rose-500/5"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 dark:via-white/5 to-transparent animate-shimmer"></div>
            
            <div className="relative flex items-center justify-between p-4 lg:p-6 backdrop-blur-sm">
                <div className="flex items-center gap-3 lg:gap-4 min-w-0">
                    {/* Animated Icon */}
                    <motion.div
                        animate={{ 
                            scale: [1, 1.1, 1],
                            rotate: [0, 5, -5, 0]
                        }}
                        transition={{ 
                            duration: 3,
                            repeat: Infinity,
                            repeatType: "reverse"
                        }}
                        className="relative flex-shrink-0"
                    >
                        <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gradient-to-br from-pink-500 via-orange-500 to-rose-600 rounded-2xl flex items-center justify-center shadow-lg shadow-pink-500/30">
                            <BsImages className="w-5 h-5 lg:w-6 lg:h-6 text-white" />
                        </div>
                        <motion.div
                            animate={{ scale: [1, 1.2, 1], opacity: [0.5, 0, 0.5] }}
                            transition={{ duration: 2, repeat: Infinity }}
                            className="absolute -top-1 -right-1 w-3 h-3 lg:w-4 lg:h-4 bg-rose-400 rounded-full"
                        />
                    </motion.div>
                    
                    <div className="min-w-0">
                        <h3 className="text-base lg:text-xl font-black bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 dark:from-white dark:via-gray-100 dark:to-white bg-clip-text text-transparent truncate">
                            {title}
                        </h3>
                        <div className="flex items-center gap-2 mt-0.5">
                            <AnimatePresence mode="wait">
                                <motion.p
                                    key={selectedImagesCount}
                                    initial={{ scale: 0.8, opacity: 0 }}
                                    animate={{ scale: 1, opacity: 1 }}
                                    exit={{ scale: 0.8, opacity: 0 }}
                                    className="text-xs lg:text-sm font-medium"
                                >
                                    <span className={`
                                        ${selectedImagesCount > 0 
                                            ? 'text-pink-600 dark:text-pink-400' 
                                            : 'text-gray-500 dark:text-gray-400'
                                        }
                                    `}>
                                        {selectedImagesCount}
                                    </span>
                                    <span className="text-gray-400 dark:text-gray-500"> / {maxImages}</span>
                                    <span className="text-gray-500 dark:text-gray-400 ml-1">images</span>
                                </motion.p>
                            </AnimatePresence>
                        </div>
                    </div>
                </div>
                
                {onClose && (
                    <motion.button
                        whileHover={{ scale: 1.1, rotate: 90 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={onClose}
                        className="p-2 lg:p-2.5 bg-gray-100/80 hover:bg-gray-200/80 dark:bg-gray-800/80 dark:hover:bg-gray-700/80 rounded-xl transition-colors backdrop-blur-sm shadow-lg flex-shrink-0"
                    >
                        <HiX className="w-4 h-4 lg:w-5 lg:h-5 text-gray-600 dark:text-gray-400" />
                    </motion.button>
                )}
            </div>
        </motion.div>
    );
};

export default ImageChatHeader; 